import { render } from "./About.vue?vue&type=template&id=639959de&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=639959de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639959de"]])

export default __exports__